// type of error
// 1. Net Work Error
//2. Server Error
// 3.Application error


export const errorTypeHandler = (error_code, error_description) => {
    if (error_code === 200) {
        return {
            error_code: error_code,
            error_description: error_description ? error_description : "Ok",
        };
    } else if (error_code === 400) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[400]- Invalid request from client !.",
        };
    } else if (error_code === 401) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[401]- Authentication Token Expired. Please refresh page.",
        };
    } else if (error_code === 404) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[404]- Requested resource did not find !.",
        };
    } else if (error_code === 405) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[405]- Requested method is not allowed !.",
        };
    } else if (error_code === 500) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[500]- Internal server error!.",
        };
    } else if (error_code === 503) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[503]- Service is unavailable !.",
        };
    } else if (error_code === 403) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[403]- This session has expired. You'll be redirected to login page after 5 seconds OR you can refresh the browser.",
        };
    } else if (error_code === 429) {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "[429]- API Rate limit reached! Please retry after a minute.",
        };
    } else if (error_code === "timeout") {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "Timeout error occurred !.",
        };
    } else if (error_code === "NO_RESPONSE") {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "No response from server !.",
        };

    }

    else if (error_code === "NET_DISCONNECTED") {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : "Internet connection issue.",
        }
    }
    else {
        return {
            error_code: error_code,
            error_description: error_description
                ? error_description
                : `[${error_code}]- UnHandled Error code`,
        };
    }
};
